import React from 'react'
import * as PropTypes from 'prop-types'

const SlackTimeAfter = props => {
  const slackTimeAfterHeight = props.timeToScreen(props.endTime + props.slackTime) - props.timeToScreen(props.endTime)

  if (slackTimeAfterHeight === 0) {
    return null
  }

  return <div className="terminal-visit-slack slack-after" style={{ height: slackTimeAfterHeight }} />
}

SlackTimeAfter.propTypes = {
  endTime: PropTypes.number.isRequired,
  slackTime: PropTypes.number.isRequired,
  timeToScreen: PropTypes.func.isRequired,
  visitStatus: PropTypes.string
}

export default SlackTimeAfter

// Remove this for now, don't know why this was ever implemented
// /**
//  * Determine whether to show (render) slack after, this depends on the state
//  * @param {TerminalVisit['status']} visitStatus
//  * @return {boolean}
//  */
// function showSlackAfter(visitStatus) {
//   return visitStatus !== VISIT_STATUSES.sailed
// }
